import { Text } from '@mantine/core';
import { IconPuzzle } from '@tabler/icons-react';
import type { AIMessage } from '~/common/vm/protocol';
import { CollapsibleCard } from '../CollapsibleCard';

export function AIComponentCallCard({ message }: { message: Extract<AIMessage, { type: 'component-call' }> }) {
  return (
    <CollapsibleCard
      icon={IconPuzzle}
      title="Component"
      badge={message.componentName}
      defaultExpanded={true}
      classNames={{ icon: 'text-gray-500 dark:text-gray-400' }}
    >
      {message.inputParams && message.inputParams.length > 0 ?
        <div className="space-y-2">
          <Text
            size="xs"
            className="mx-1 tracking-wide text-gray-500 dark:text-gray-400"
          >
            Input parameters
          </Text>
          {message.inputParams.map((p) => (
            <div
              key={p.name}
              className="mx-1 rounded border border-gray-200 bg-gray-50 p-2 dark:border-gray-600 dark:bg-gray-700"
            >
              <Text
                size="sm"
                className="leading-relaxed"
              >
                {p.name}: "{p.value}"
              </Text>
            </div>
          ))}
        </div>
      : <Text
          size="sm"
          className="mx-1 text-gray-600 dark:text-gray-300"
        >
          No input parameters
        </Text>
      }
    </CollapsibleCard>
  );
}
